import { enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { basicAuthorizationInterceptor } from './app/core/interceptors/basic-authorization.interceptor';
import { cleverAuthorizationInterceptor } from './app/core/interceptors/clever-authorization.interceptor';
import { classlinkAuthorizationInterceptor } from './app/core/interceptors/classlink-authorization.interceptor';
import { noCacheInterceptor } from './app/core/interceptors/no-cache.interceptor';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { APP_ROUTES } from './app/app.routes';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.SENTRY_DSN,
  release: environment.versionNumber,
  environment: environment.production ? 'production' : 'dev',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration(),
  ],
})

bootstrapApplication(
  AppComponent,
  {
    providers: [
      provideZoneChangeDetection(),
      provideRouter(APP_ROUTES),
      provideHttpClient(
        withInterceptors([
          basicAuthorizationInterceptor,
          cleverAuthorizationInterceptor,
          classlinkAuthorizationInterceptor,
          noCacheInterceptor
        ])
      ),
      importProvidersFrom(BrowserModule, BrowserAnimationsModule),
      { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false, }) },
    ]
  }
).catch(err => console.error(err));
